export { CollapsibleComponent as Collapsible } from './Collapsible';
export type { CollapsiblePropTypes } from './Collapsible.types';
